(function ($) {
  $.fn.visible = function (partial) {

    var $t = $(this);

    if ($t.length > 0) {
      var $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    }
  };

})(jQuery);

var win = $(window);
var counter = $('.counter-number');
var counterFlag = 0;
var slideInLeft = [];
slideInLeft.push(
  $('.block-1-text'),
  $('.landscape-image-layout-left > .text-column'),
  $('.portrait-image-layout-left > .text-column'),
  $('.image-text-block > .text-container'),
  $('.build-blue-text-over-image .align-textbox-left > .text-block'),
  $('.text-block-over-image .align-textbox-left > .text-block'),
  $('#portfolio-metadata-column')
);

var slideInRight = [];
slideInRight.push(
  $('.block-2-text'),
  $('.landscape-image-layout-right > .text-column'),
  $('.portrait-image-layout-right > .text-column'),
  $('.build-blue-text-over-image .align-textbox-right > .text-block'),
  $('.text-block-over-image .align-textbox-right > .text-block'),
  $('.text-with-blurb p.blurb-text'),
  $('#portfolio-description-column')
);

win.scroll(function () {

  if ($(document).scrollTop() > 160) {
    $('#desktop-nav').addClass('shrink');
    $('#desktop-nav > .container').addClass('shrink');
    $('#brand-logo').addClass('shrink');
    $('#section-nav').addClass('shrink');
  }
  if ($(document).scrollTop() < 80) {
    $('#desktop-nav').removeClass('shrink');
    $('#desktop-nav > .container').removeClass('shrink');
    $('#brand-logo').removeClass('shrink');
    $('#section-nav').removeClass('shrink');
  }

  // custom counter widget on portfolio pages
  if (counterFlag == 0) {
    $.each(counter, function (i, el) {
      var sel = $(el);
      if (sel.visible(true)) {
        sel.off('scroll');
        sel.prop('Counter', 0).animate({
          Counter: sel.text(),
        }, {
          duration: 4000,
          easing: 'swing',
          step: function (now) {
            sel.text(Math.ceil(now).toLocaleString());
          },
        });
        counterFlag = 1;
      }
    });
  }

  $.each(slideInLeft, (function (i, el) {
    var sel = $(el);
    if (sel.visible(true)) {
      sel.addClass('animate__animated');
      sel.addClass('animate__slideInLeft');
      sel.css('visibility', 'visible');
    }
  }));

  $.each(slideInRight, (function (i, el) {
    var sel = $(el);
    if (sel.visible(true)) {
      sel.addClass('animate__animated');
      sel.addClass('animate__slideInRight');
      sel.css('visibility', 'visible');
    }
  }));
});

// custom counter widget on portfolio pages
if (counterFlag == 0) {
  $.each(counter, function (i, el) {
    var sel = $(el);
    if (sel.visible(true)) {
      sel.off('scroll');
      sel.prop('Counter', 0).animate({
        Counter: sel.text(),
      }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
          sel.text(Math.ceil(now).toLocaleString());
        },
      });
      counterFlag = 1;
    }
  });
}

$.each(slideInLeft, (function (i, el) {
  var sel = $(el);
  if (sel.visible(true)) {
    sel.addClass('animate__animated');
    sel.addClass('animate__slideInLeft');
    sel.css('visibility', 'visible');
  }
}));

$.each(slideInRight, (function (i, el) {
  var sel = $(el);
  if (sel.visible(true)) {
    sel.addClass('animate__animated');
    sel.addClass('animate__slideInRight');
    sel.css('visibility', 'visible');
  }
}));




// WEBPACK FOOTER //
// ./scripts/scrollFunctions.js